import { Image } from 'expo-image'
import { withUnistyles } from 'react-native-unistyles'

const UniImage = withUnistyles(Image)

export default UniImage
